<template>
    <bottom-sheet v-model="shows" v-bind="{ title }" fullscreen persistent maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="fill-height d-flex flex-column">
            <div style="flex:1; overflow:hidden">
                <employment-doc-view
                    v-bind="{
                        contract: form,
                        value: fields,
                        pages,
                        mode: 'done',
                    }"
                />
            </div>
            <client-loader v-bind="{ loading }" />
        </v-layout>
    </bottom-sheet>
</template>

<script>
import { mapState } from "vuex";

import api from "@/api";
import { initEmploymentContract, USER_TYPES } from "@/assets/variables";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import ClientLoader from "@/components/client/dumb/client-loader.vue";
import EmploymentDocView from "@/components/dashboard/common/employment/doc/employment-doc-view.vue";

export default {
    components: {
        BottomSheet,
        ClientLoader,
        EmploymentDocView,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        value: { type: Object, default: initEmploymentContract },
    },
    data: () => ({
        form: initEmploymentContract(),
        shows: false,
        loading: false,
    }),
    computed: {
        ...mapState({
            userType: ({ user }) => user?.type,
        }),
        title() {
            return `"${this.form.subject}" 자세히 보기`;
        },
        fields() {
            return [...this.form.fields_document, ...this.form.fields_employee];
        },
        pages() {
            return this.form?.form?.pages || [];
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        shows() {
            this.init();
        },
    },
    methods: {
        async init() {
            if (!this.shows) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let get = (() => {
                    switch (this.userType) {
                        case USER_TYPES.COMPANY.value: {
                            return api.v1.company.employment.contracts.get;
                        }
                        case USER_TYPES.PERSON.value: {
                            return api.v1.person.employment.contracts.get;
                        }
                    }
                })();
                let { contract } = await get({ _id: this.value._id });
                this.form = initEmploymentContract(contract);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>
